import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withFadeInUpAnimation from '../../hocs/withFadeInUpAnimation'

export class AuthCard extends Component {
  render() {
    const { title, subtitle, children } = this.props
    return (
      <div
        className="card shadow"
        style={{
          marginTop: '30px',
        }}
      >
        <div className="card-body text-center">
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <h3 className="card-title">{title}</h3>
              <h5 className="card-subtitle">{subtitle}</h5>
            </div>
          </div>
          {children}
        </div>
      </div>
    )
  }
}

AuthCard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default withFadeInUpAnimation(AuthCard)



// WEBPACK FOOTER //
// ./src/components/ui/cards/AuthCard.js